// src/store/challenge/challengeThunk.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getChallengesAPI,
  getChallengeByIdAPI,
  updateChallengeProgressAPI,
  createChallengeAPI
} from './challengeAPI';

// Fetch all challenges
export const fetchChallenges = createAsyncThunk(
  'challenge/fetchAll',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await getChallengesAPI(params);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to fetch challenges'
      );
    }
  }
);

// Fetch challenge by ID
export const fetchChallengeById = createAsyncThunk(
  'challenge/fetchById',
  async (challengeId, { rejectWithValue }) => {
    try {
      const response = await getChallengeByIdAPI(challengeId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to fetch challenge'
      );
    }
  }
);

// Update challenge progress
export const updateChallengeProgress = createAsyncThunk(
  'challenge/updateProgress',
  async ({ challengeId, progressData }, { rejectWithValue }) => {
    try {
      const response = await updateChallengeProgressAPI(challengeId, progressData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to update challenge progress'
      );
    }
  }
);

// Create new challenge (Admin)
export const createChallenge = createAsyncThunk(
  'challenge/create',
  async (challengeData, { rejectWithValue }) => {
    try {
      const response = await createChallengeAPI(challengeData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to create challenge'
      );
    }
  }
);